<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-list">
		<vs-prompt
			:title="$t('ExportToExcel') + ' ' + $t('Selected')"
			class="export-options"
			@cancel="clearFields"
			@accept="exportList"
			accept-text="Export"
			@close="clearFields"
			:active.sync="activePrompt1"
		>
			<vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
			<v-select v-model="selectedFormat" :options="formats" class="my-4" />
			<div class="flex">
				<span class="mr-4">{{ $t("MapModule.CellAutoWith") }}:</span>
				<vs-switch v-model="cellAutoWidth">{{ $t("MapModule.CellAutoWith") }}</vs-switch>
			</div>
		</vs-prompt>
		<vs-prompt
			:title="$t('ExportToExcel') + ' ' + $t('All')"
			class="export-options"
			@cancel="clearFields"
			@accept="exportList2"
			accept-text="Export"
			@close="clearFields"
			:active.sync="activePrompt2"
		>
			<v-select v-model="typologyIdForExport" :options="typologyOptions" class="my-4" />
			<v-select v-model="selectedFormat" :options="formats" class="my-4" />
			<div class="flex">
				<span class="mr-4">{{ $t("MapModule.CellAutoWith") }}:</span>
				<vs-switch v-model="cellAutoWidth">{{ $t("MapModule.CellAutoWith") }}</vs-switch>
			</div>
		</vs-prompt>
		<vs-prompt
			:title="$t('VisitPointObject.List.NotSchedule')"
			class="export-options"
			@cancel="clearFields"
			@accept="visitPointNotSchedule"
			:accept-text="$t('Search')"
			@close="clearFields"
			:active.sync="activePrompt3"
		>
			<div class="vx-row">
				<div class="vx-col md:w-1/1 sm:w-1/1 w-full">
					<vs-alert
						color="danger"
						:title="$t('VisitPointObject.List.InvalidRangeOfDateTitle')"
						:active.sync="max_days_alert"
						closable
						icon-pack="feather"
						close-icon="icon-x"
					>
						<span>{{ vs_alert_msg }}</span>
					</vs-alert>
				</div>
				<div class="vx-col md:w-1/1 sm:w-1/1 w-full">
					<label class="text-sm opacity-75">{{ $t("InitDate") }}</label>
					<datepicker
						:language="$vs.rtl ? langHe : langEn"
						class="mb-4 md:mb-0 mr-4"
						name="start-date"
						v-model="startDate"
					></datepicker>
				</div>
				<div class="vx-col md:w-1/1 sm:w-1/1 w-full">
					<label class="text-sm opacity-75">{{ $t("EndDate") }}</label>
					<datepicker
						:language="$vs.rtl ? langHe : langEn"
						class="mb-4 md:mb-0 mr-4"
						:disabledDates="disabledDatesTo"
						name="end-date"
						v-model="endDate"
					></datepicker>
				</div>
			</div>
		</vs-prompt>
		<!-- Slot para agregar contenido desde los componentes donde se implemente -->
		<slot></slot>
		<div class="vx-row" v-if="customConfig.tableOptions">
			<div class="vx-col flex w-full md:w-3/4 mb-2">
				<!-- ITEMS PER PAGE -->
				<template>
					<!-- ITEMS PER PAGE -->
					<vs-dropdown vs-trigger-click class="cursor-pointer mr-2 w-1/2">
						<div
							class="
								p-3
								border border-solid
								d-theme-border-grey-light
								rounded-lg
								d-theme-dark-bg
								cursor-pointer
								font-medium
							"
						>
							<span>{{ $t(`SearchBy`) }} {{ searchSelected }}</span>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu>
							<vs-dropdown-item @click="setSearchField('Identification')">
								<span>{{ $t("Identification") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Name')">
								<span>{{ $t("Name") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Address')">
								<span>{{ $t("Address") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('City')">
								<span>{{ $t("City") }}</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</template>
				<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
				<vx-input-group v-if="customConfig.showSearch" class="w-full">
					<vs-input
						icon-no-border
						class="w-full"
						v-model="searchQuery"
						:placeholder="$t('Search')"
						@keyup.enter="searchResource"
					/>
					<template slot="append">
						<div class="btn-addon">
							<vs-button
								type="filled"
								class="cursor-pointer"
								color="primary"
								icon-pack="feather"
								icon="icon-search"
								:title="$t('Search')"
								@click.prevent="searchResource"
							></vs-button>
						</div>
					</template>
				</vx-input-group>
			</div>
			<div class="vx-col flex md:w-1/4 mb-2">
				<vx-tooltip
					v-if="1 === 2"
					class="cursor-pointer mr-2"
					position="top"
					:text="$t('Export') + ' ' + $t('VisitPoints')"
				>
					<vs-button
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-download"
						@click.prevent="activateExport"
					></vs-button>
				</vx-tooltip>
				<vx-tooltip class="cursor-pointer mr-3" position="top" :text="$t('Schedule.Refresh')">
					<vs-button
						type="filled"
						color="primary"
						icon-pack="feather"
						icon="icon-refresh-cw"
						@click.prevent="refreshVisitPoint"
					></vs-button>
				</vx-tooltip>
				<vx-tooltip
					v-if="customConfig.showActions"
					class="cursor-pointer mr-3"
					position="top"
					:text="$t('New')"
				>
					<vs-button
						type="filled"
						icon-pack="feather"
						icon="icon-plus"
						@click.prevent="$router.push('/apps/visit-point/create')"
					></vs-button>
				</vx-tooltip>
				<!-- ACTION - DROPDOWN -->
				<vs-dropdown v-if="customConfig.showActions" vs-trigger-click class="cursor-pointer">
					<div
						class="
							p-3
							shadow-drop
							rounded-lg
							d-theme-dark-light-bg
							cursor-pointer
							flex
							items-end
							justify-center
							text-lg
							font-medium
							w-32
							bg-primary
						"
					>
						<span class="mr-2 g-text text-white">{{ $t("Actions") }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 text-grey" />
					</div>
					<vs-dropdown-menu>
						<vs-dropdown-item @click="activePrompt3 = true">
							<span class="flex items-center">
								<feather-icon icon="BellOffIcon" svgClasses="h-4 w-4" class="mr-2" />
								<span>{{ $t("VisitPointObject.List.NotSchedule") }}</span>
							</span>
						</vs-dropdown-item>
						<vs-dropdown-item
							@click="confirmMassiveDelete('MULTI')"
							v-show="visitpointIdsSelected.length > 0 && visitpointDeletePermission"
						>
							<span class="flex items-center">
								<feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" class="mr-2" />
								<span class="g-label--normal">{{ $t("Crud.Delete") }} {{ $t("Selection") }}</span>
							</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="confirmMassiveDelete('MASIVE')" v-if="massiveDeletePermission">
							<span class="flex items-center">
								<feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
								<span class="g-label--normal">{{ $t("MassiveDelete") }}</span>
							</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
		</div>
		<!-- AgGrid Table -->
		<ag-grid-vue
			ref="agGridTable"
			class="ag-theme-material w-100 my-2"
			:class="
				customConfig.typeComponent === 'EventForm' ? 'ag-grid-table' : 'ag-grid-table-cutomize ag-grid-table'
			"
			colResizeDefault="shift"
			:components="components"
			:gridOptions="gridOptions"
			:columnDefs="columnDefs"
			:defaultColDef="defaultColDef"
			:rowData="usersData"
			:rowSelection="customConfig.rowSelection"
			:animateRows="true"
			:enableRtl="$vs.rtl"
			@rowSelected="rowSelected"
			@selection-changed="onSelectionChanged"
			@grid-ready="onGridReady"
		>
		</ag-grid-vue>
		<vs-pagination :total="totalPages" :max="5" v-model="currentPage" goto />
		<div v-if="1 === 2" class="text-right">
			<vs-button
				type="filled"
				color="#31C918"
				class="g-btn--resourcePopup"
				:disabled="getCheckedVisitPoints.length <= 0"
				@click="getVisitPointSelected"
			>
				{{ $t("Resource.AssigResources") }}
			</vs-button>
		</div>
	</div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
// Store Module
import moduleResource from "@/store/resource/moduleResource.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleCommon from "@/store/common/moduleCommon.js";
// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererType from "./cell-renderer/CellRendererType.vue";
import CellRendererAdditionalFields from "./cell-renderer/CellRendererAdditionalFields.vue";
import {firebaseInstance as firebase} from "@/main";
// Utilities
import DateUtils from "@/helpers/DateUtils.js";

export default {
	props: {
		massiveDeletePermission: {
			type: Boolean,
			default: false,
		},
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: true,
					activeHeaderCheckboxSelection: true,
					activeLink: true,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showSearch: true,
					showActions: true,
					typeComponent: "",
					cellRendererAdditionalFields: false,
				};
			},
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		resource_id: {
			type: Number,
			default: null,
		},
		componentParent: {
			type: String,
			default: "principal",
		},
		status_id: {
			type: Array,
			default: () => [],
		},
		openLoadFileForm: {
			type: Function,
		},
		drPointsActivity: {
			type: Number,
			default: 0,
		},
	},
	components: {
		AgGridVue,
		vSelect,
		Datepicker,
		CellRendererLink,
		CellRendererStatus,
		CellRendererVerified,
		CellRendererActions,
		CellRendererType,
		CellRendererAdditionalFields,
	},
	data() {
		return {
			// Filter Options
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: this.$t("All"), value: "all"},
			statusOptions: [
				{label: this.$t("All"), value: "all"},
				{label: this.$t("VisitPointObject.List.NotSchedule"), value: "notSchedule"},
			],
			isVerifiedFilter: {label: "All", value: "all"},
			departmentFilter: {label: "All", value: "all"},
			searchQuery: "",
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 20,
			// AgGrid
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			// Cell Renderer Components
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererVerified,
				CellRendererActions,
				CellRendererType,
				CellRendererAdditionalFields,
			},
			visitpointIdsSelected: [],
			radioTypeSearch: "default",
			searchField: "Name",
			//Variables to Export Files
			fileName: "",
			formats: ["xlsx", "csv", "txt"],
			cellAutoWidth: true,
			selectedFormat: "xlsx",
			activePrompt1: false,
			activePrompt2: false,
			activePrompt3: false,
			headerTitle: [
				this.$t("Name"),
				this.$t("Identification"),
				this.$t("Address"),
				this.$t("City"),
				this.$t("Country"),
				this.$t("Phone"),
				"Cx",
				"Cy",
				"added_on",
				"update_on",
				this.$t("Zonification.Zone"),
				"Zip_Code",
			],
			headerVal: [
				"name",
				"identification",
				"address",
				"city",
				"country",
				"phone",
				"cx",
				"cy",
				"added_on",
				"update_on",
				"zone",
				"zip_code",
			],
			selectedResourcesToExport: [],
			typologyIdForExport: 0,
			typologyOptions: [],
			startDate: new Date(),
			endDate: new Date(),
			showDate: new Date(),
			numberDaysInMont: 30,
			langHe: es,
			langEn: en,
			all_visit_points: [],
			max_days_alert: false,
			vs_alert_msg: "",
			checkedAll: false,
			filterBy: "dafault",
			filtarOptions: {},
			ON_DEMAND: "ON_DEMAND",
			localDrPointsActivity: 0,
		};
	},
	watch: {
		roleFilter(obj) {
			this.setColumnFilter("typology_name", obj.value);
		},
		statusFilter(obj) {
			if (obj.value === "all") {
				this.currentPageLocal = 1;
				this.getVisitPoint(this.currentPageLocal);
			}
		},
		isVerifiedFilter(obj) {
			const val = obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
			this.setColumnFilter("is_verified", val);
		},
		departmentFilter(obj) {
			this.setColumnFilter("department", obj.value);
		},
		currentPageLocal(page) {
			if (this.statusFilter.value === "notSchedule" && this.all_visit_points.length > 0) {
				this.getVisitPoint(page, this.all_visit_points);
			} else if (this.filterBy === "additionalFields") {
				const {typology_id, additional_info} = this.filtarOptions;
				this.searchByAdditionalFields(typology_id, additional_info);
			} else if (this.filterBy === "properties") {
				const {searchField, searchQuery} = this.filtarOptions;
				this.searchResource2(searchField, searchQuery);
			} else {
				this.getVisitPoint(page);
			}
		},
		quantityElementPage() {
			this.getVisitPoint(1);
		},
		radioTypeSearch() {
			this.searchQuery = "";
			this.resetColFilters();
			if (this.radioTypeSearch === "default") {
				this.getVisitPoint();
			}
		},
		drPointsActivity(val) {
			if (this.localDrPointsActivity === val) return;
			this.localDrPointsActivity = val;
			this.refreshVisitPoint();
		},
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		/* =================================================================
          NOTE:
          Header is not aligned properly in RTL version of agGrid table.
          However, we given fix to this issue. If you want more robust solution please contact them at gitHub
        ================================================================= */
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.dataSelectVisitPoint.category === undefined) {
			this.$store.dispatch("moduleCommon/fetchDataSelectVisitPoint").catch((error) => {
				throw new Error(error);
			});
		}
		this.typologyOptionsFetch();
	},
	beforeDestroy() {
		this.$store.dispatch("moduleVisitPoint/setSelectedVisitPoint", []);
		this.$store.commit("moduleVisitPoint/CLEAR_DEL_VISIT_POINT_CHECKED");
	},
	computed: {
		visitpointDeletePermission() {
			return this.$store.getters.checkPermission("VISIT_POINT_D");
		},
		usersData() {
			return this.$store.state.moduleVisitPoint.visitPoints;
		},
		columnDefs() {
			let filterHead = false;
			let columns = [
				{
					headerName: this.$t("Name"),
					field: "name",
					width: 350,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
					cellRendererFramework: this.customConfig.activeLink ? "CellRendererLink" : null,
				},
				{
					headerName: this.$t("Identification"),
					field: "identification",
					filter: filterHead,
					width: 250,
				},
				{
					headerName: this.$t("Address"),
					field: "address",
					filter: filterHead,
					width: 255,
				},
				{
					headerName: this.$t("City"),
					field: "city",
					filter: filterHead,
					width: 250,
				},
				{
					headerName: this.$t("Phone"),
					field: "phone",
					width: 150,
				},
				{
					headerName: this.$t("Status"),
					field: "status_name",
					width: 150,
					filter: filterHead,
					cellRendererFramework: "CellRendererStatus",
				},
				{
					headerName: this.$t("ObjectType"),
					field: "typology_name",
					width: 250,
					filter: filterHead,
					cellRendererFramework: "CellRendererType",
				},
				{
					headerName: this.$t("Actions"),
					field: "transactions",
					width: 150,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			if (this.customConfig.cellRendererAdditionalFields) {
				columns.push({
					headerName: this.$t("Object.AdditionalFields"),
					field: "additional_info",
					width: 350,
					filter: filterHead,
					cellRendererFramework: "CellRendererAdditionalFields",
				});
			}
			// Filter table columns to show if showColumns is provided
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		disabledDatesTo() {
			return {to: new Date(this.startDate)};
		},
		disabledDatesFrom() {
			return {to: new Date()};
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		typeOptions(value) {
			const categories = this.$store.state.moduleCommon.dataSelectVisitPoint.category;
			if (categories === undefined) {
				return [];
			}
			const data = this.generateOptionSelect(categories, "typology_name", "typology_name");
			data.unshift({label: "All", value: "all"});
			return data;
		},
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoits;
		},
		searchSelected() {
			return this.$t(`${this.searchField}`);
		},
	},
	methods: {
		async getPermissions() {
			const user = await this.userSession.getUser();
			this.permissions = user.permissions;
			this.role = user.role_name;
		},
		getVisitPointSelected() {
			this.setAssignedVisitPoint();
		},
		massiveDelete() {
			this.$store.dispatch("moduleVisitPoint/removeMassiveVisitPoint");
		},
		multiDelete() {
			const payload = {
				visitpoint_id: this.visitpointIdsSelected,
			};
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/removeMultiVisitPoint", payload)
				.then((res) => {
					this.showMsg();
					this.closeLoading();
					this.visitpointIdsSelected = [];
					this.$store.dispatch("moduleVisitPoint/setSelectedVisitPoint", []);
					this.$store.commit("moduleVisitPoint/CLEAR_DEL_VISIT_POINT_CHECKED");
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		confirmMassiveDelete(option = "MULTI") {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title:
					option === "MASIVE"
						? this.$t("VisitPointObject.List.MassiveDelete.Confirm.Title")
						: this.$t("general.RemoveSelection"),
				text: this.$t("VisitPointObject.List.MassiveDelete.Confirm.Text"),
				accept: option === "MASIVE" ? this.massiveDelete : this.multiDelete,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		showMsg() {
			this.$vs.notify({
				color: "success",
				title: this.$t("VisitPointObject.List.MassiveDelete.Success.Title"),
				text: this.$t("VisitPointObject.List.MassiveDelete.Success.Text"),
			});
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getVisitPoint(page, id = []) {
			this.openLoading();
			const payload = {
				order_by: "added_on",
				sort: "DESC",
				page,
				quantity: id.length > 0 ? 1000 : this.quantityElementPage,
				resource_id: this.resource_id,
				id,
				status_id: this.status_id,
			};
			// Validamos si el llamado es desde on demand para agregar filtro al servicio
			if (this.componentParent === this.ON_DEMAND) {
				payload["on_demand"] = this.drPointsActivity > 0;
			}
			this.$store
				.dispatch("moduleVisitPoint/fetchVisitPointPaginated", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			// Reset Grid Filter
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			if (this.radioTypeSearch === "default") this.gridApi.setQuickFilter(val);
		},
		crear() {
			this.$router.push(`/apps/resource/user-create`);
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		onGridReady() {
			this.getVisitPoint(1);
		},
		rowSelected(event) {
			if (this.selectedResourcesToExport.some((ele) => ele.id === event.data.id)) {
				this.selectedResourcesToExport = this.selectedResourcesToExport.filter(
					(ele2) => ele2.id !== event.data.id
				);
			} else {
				this.selectedResourcesToExport.push(event.data);
			}
			const isSelected = event.node.isSelected();
			if (isSelected) {
				// Almacenamos en el state el ultimo valor seleccionado del listado
				this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED", event.data);
				this.$emit("selected", event.data);
			} else {
				this.$store.commit("moduleVisitPoint/DEL_VISIT_POINT_CHECKED", event.data);
			}
		},
		onSelectionChanged() {
			const selectedRows = this.getCheckedVisitPoints; //this.gridApi.getSelectedRows();
			if (this.customConfig.rowSelection === "single") {
				this.$store.dispatch("moduleVisitPoint/currentVisitPointSelected", selectedRows[0]);
			} else {
				this.$store.dispatch("moduleVisitPoint/setSelectedVisitPoint", selectedRows);
			}
			this.visitpointIdsSelected = selectedRows.map(({id}) => id);
		},
		clearSelectedRow() {
			this.gridApi.forEachNode((node) => {
				node.setSelected(false);
			});
		},
		searchResource() {
			const dataPage = {
				name: this.searchField === "Name" ? this.searchQuery : "",
				address: this.searchField === "Address" ? this.searchQuery : "",
				city: this.searchField === "City" ? this.searchQuery : "",
				identification: this.searchField === "Identification" ? this.searchQuery : "",
				order_by: "name",
				sort: "ASC",
				resource_id: this.resource_id,
				status_id: this.status_id,
			};
			// Validamos si el llamado es desde on demand para agregar filtro al servicio
			if (this.componentParent === this.ON_DEMAND) {
				dataPage["on_demand"] = true;
			}
			this.$store
				.dispatch("moduleVisitPoint/fetchVisitPointPaginated", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		searchResource2(searchField, searchQuery, page) {
			this.filterBy = "properties";
			this.filtarOptions = {searchField, searchQuery};
			const payload = {
				name: searchField === "Name" ? searchQuery : "",
				city: searchField === "City" ? searchQuery : "",
				identification: searchField === "Identification" ? searchQuery : "",
				address: searchField === "Address" ? searchQuery : "",
				order_by: "name",
				sort: "ASC",
				page: page ? page : this.currentPageLocal,
				quantity: this.quantityElementPage,
				status_id: this.status_id,
			};
			this.openLoading();
			// Validamos si el llamado es desde on demand para agregar filtro al servicio
			if (this.componentParent === this.ON_DEMAND) {
				payload["on_demand"] = this.drPointsActivity > 0;
			}
			this.$store
				.dispatch("moduleVisitPoint/fetchVisitPointPaginated", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		searchByAdditionalFields(typology_id = [], additional_info = [], page, exact_values = false) {
			this.filterBy = "additionalFields";
			this.filtarOptions = {typology_id, additional_info};
			const payload = {
				page: page ? page : this.currentPageLocal,
				quantity: this.quantityElementPage,
				order_by: "name",
				sort: "ASC",
				typology_id,
				additional_info,
				status_id: this.status_id,
				exact_values,
			};
			this.openLoading();
			if (this.componentParent === this.ON_DEMAND) {
				payload["on_demand"] = this.drPointsActivity > 0;
			}
			this.$store
				.dispatch("moduleVisitPoint/fetchVisitPointPaginated", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		setSearchField(val) {
			this.searchField = val;
		},
		refreshVisitPoint() {
			this.searchQuery = "";
			this.currentPageLocal = 1;
			this.$store.dispatch("moduleVisitPoint/setSelectedVisitPoint", []);
			this.$store.commit("moduleVisitPoint/CLEAR_DEL_VISIT_POINT_CHECKED");
			this.getVisitPoint(1);
		},
		// Este metodo se utiliza cuando el componente esta mondatos desde el componente de actividades
		setAssignedVisitPoint() {
			const selectedRows = [...this.getCheckedVisitPoints]; //this.gridApi.getSelectedRows();
			this.$store.commit("moduleVisitPoint/SET_ASSIGNED_VISIT_POINT", selectedRows);
			this.$emit("showPopupVisitPointEmmit", false);
		},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedVisitPoints;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		//CODIGO PARA EXPORTAR
		activateExport() {
			if (this.selectedResourcesToExport.length >= 1) {
				this.showActivePrompt1();
			} else {
				this.showActivePrompt2();
			}
		},
		async exportList() {
			this.openLoading();
			await import("@/vendor/Export2Excel").then((excel) => {
				const list = this.getCheckedVisitPoints;
				const data = this.formatJson(this.headerVal, list);
				excel.export_json_to_excel({
					header: this.headerTitle,
					data,
					filename: this.fileName,
					autoWidth: this.cellAutoWidth,
					bookType: this.selectedFormat,
				});
				this.clearFields();
				this.closeLoading();
			});
		},
		async exportList2() {
			//From BACKEND all resources
			this.openLoading();
			let payload = {
				typology_id: this.typologyIdForExport.value,
				type_file: this.selectedFormat,
			};
			await this.$store
				.dispatch("moduleVisitPoint/downloadVisitPoints", payload)
				.then((res) => {
					if (res.data === null || res.data.length === 0) {
						this.$vs.notify({
							color: "danger",
							title: this.$t(""),
							text: this.$t("VisitPointObject.Edit.VisitPointNotFound.Title"),
						});
						this.closeLoading();
						return;
					}
					const storageRef = firebase.storage().ref(res.data.bucket_path);
					storageRef
						.getDownloadURL()
						.then(function (url) {
							const downloadInstance = document.createElement("a");
							downloadInstance.href = url;
							downloadInstance.target = "_blank";
							downloadInstance.download = "default.xlsx";
							document.body.appendChild(downloadInstance);
							downloadInstance.click();
							document.body.removeChild(downloadInstance);
						})
						.then(() => this.closeLoading());
				})
				.catch((err) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t(""),
						text: this.$t("VisitPointObject.Edit.VisitPointNotFound.Title"),
					});
					throw new Error(err);
				});
			this.$nextTick(() => this.closeLoading());
		},
		clearFields() {
			this.fileName = "";
			this.cellAutoWidth = true;
			this.selectedFormat = "xlsx";
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					return v[j];
				})
			);
		},
		showActivePrompt1() {
			this.activePrompt1 = true;
		},
		showActivePrompt2() {
			this.activePrompt2 = true;
		},
		async typologyOptionsFetch() {
			let categories = [];
			const payload = {
				role: [],
				status: [],
				category: "VISIT_POINT",
				typology: [],
			};
			await this.$store
				.dispatch("moduleResource/fetchDataSelect", payload)
				.then((res) => {
					categories = res.data.category.map((ele) => {
						return {label: ele.typology_name, value: ele.typology_id};
					});
					this.typologyOptions = categories;
					this.typologyIdForExport = categories[0];
				})
				.catch((error) => {
					throw new Error(error);
				});
			return categories;
		},
		differentceInDaysBetweenDates(dateI, dateF) {
			const totalTime = dateF.getTime() - dateI.getTime(); // To calculate the no. of days between two dates
			const totalDays = totalTime / (1000 * 3600 * 24);
			return totalDays;
		},
		visitPointNotSchedule() {
			const numDays = this.differentceInDaysBetweenDates(this.startDate, this.endDate);
			if (Math.sign(numDays) === -1) {
				this.max_days_alert = true;
				this.vs_alert_msg = this.$t("Alarm.DateInitError");
				if (this.componentParent === "principal") {
					this.activePrompt3 = true;
				}
				return;
			}
			if (numDays > 32) {
				this.max_days_alert = true;
				this.vs_alert_msg = this.$t("VisitPointObject.List.InvalidRangeOfDateMsj");
				if (this.componentParent === "principal") {
					this.activePrompt3 = true;
				}
				return;
			}
			const payload = {
				init_date: DateUtils.toDefaultDateTime(this.startDate, "YYYY-MM-DD"),
				end_date: DateUtils.toDefaultDateTime(this.endDate, "YYYY-MM-DD"),
			};
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/fetchVisitpointsnotscheduled", payload)
				.then((res) => {
					this.currentPageLocal = 1;
					this.all_visit_points = res.data.all_visit_points;
					this.getVisitPoint(this.currentPageLocal, this.all_visit_points);
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}
}

.radio-alignment {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: center;

	& > * {
		margin-right: 1.5rem;
		margin-top: 1.5rem;
	}
}

.ag-grid-table-cutomize {
	&.ag-theme-material {
		font-style: normal;
		font-weight: 300;
		font-size: 12px;
		line-height: 15px;
		color: #666666;
	}

	@media screen and (max-height: 800px) {
		height: 300px;
	}
}
</style>
